// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import 'font-awesome/css/font-awesome.css'
import { sync } from 'vuex-router-sync'
import setupRoute from './router/setup'
import setupApi from './api/setup'
import setupPlugins from './plugins/setup'

Vue.config.productionTip = false

sync(store, router)
setupRoute()
setupApi()
setupPlugins()

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js